import WhatIsAmsTrainerComponent from "../../components/become-trainer/what-is-ams-trainer";

const WhatIsAMSTrainerPage = () => <WhatIsAmsTrainerComponent/>

export default WhatIsAMSTrainerPage;